import './polyfills';
import { utils } from 'pixi.js';
import App from './app';
import config from 'config';
import tools from 'tools';
import assets from 'app/assets';
import gsap from 'gsap';
import localeManager from 'app/assets/localeManager';
import sdkMock from './lib/sdkMock';
import { Howler } from 'howler';
import youtubePlayables from './lib/youtubePlayables';

utils.skipHello();

export default class Game {
  constructor() {
    tools.autobind(this);
    config.sdk = sdkMock;
    config.youtubePlayables = youtubePlayables;
    youtubePlayables.init();
    config.platform = tools.setupIs().android ? "android" : tools.setupIs().ios ? "ios" : "desktop";
    config.sdk.addEventListener('onLoadingStart', this.startLoadingGameHandler, 1);
    config.sdk.addEventListener('onLoadingEnd', this.sdkLoadedHandler, 1);
    config.sdk.getPlatform().init();
    config.sdk.addEventListener("reconnected", notif => {
      const payload = notif.getPayload ? notif.getPayload() : notif;
      const reconnected = payload.reconnected;
      if (reconnected) {
        if (!config.header) {
          this.checkHeaderInterval = setInterval(() => {
            if (config.header) {
              this.checkHeaderInterval && clearInterval(this.checkHeaderInterval);
              this.initFromReconnect();
            }
          }, 60);
        } else {
          this.initFromReconnect();
        }
      }
      config.reconnected = reconnected;
    });
  }
  initLoadingOverlay() {
    if (this.loadingOverlayEl) return;
    const overlay = document.createElement("div");
    overlay.id = "game-loading-overlay";
    overlay.style.position = "fixed";
    overlay.style.inset = "0";
    overlay.style.display = "flex";
    overlay.style.flexDirection = "column";
    overlay.style.alignItems = "center";
    overlay.style.justifyContent = "center";
    overlay.style.background = "#0b2944";
    overlay.style.zIndex = "99999";
    overlay.style.opacity = "1";
    overlay.style.transition = "opacity 220ms ease";
    const label = document.createElement("div");
    label.textContent = "Loading 0%";
    label.style.color = "#ffffff";
    label.style.fontFamily = "Arial, sans-serif";
    label.style.fontSize = "18px";
    label.style.marginBottom = "12px";
    const track = document.createElement("div");
    track.style.width = "240px";
    track.style.maxWidth = "70vw";
    track.style.height = "10px";
    track.style.borderRadius = "999px";
    track.style.background = "rgba(255,255,255,0.25)";
    track.style.overflow = "hidden";
    const fill = document.createElement("div");
    fill.style.height = "100%";
    fill.style.width = "0%";
    fill.style.borderRadius = "999px";
    fill.style.background = "#10b7fe";
    fill.style.transition = "width 120ms linear";
    track.appendChild(fill);
    overlay.appendChild(label);
    overlay.appendChild(track);
    document.body.appendChild(overlay);
    this.loadingOverlayEl = overlay;
    this.loadingBarEl = fill;
    this.loadingLabelEl = label;
  }
  updateLoadingOverlay(progress = 0) {
    if (!this.loadingOverlayEl) return;
    const safeProgress = Math.max(0, Math.min(100, Math.round(progress)));
    this.loadingBarEl && (this.loadingBarEl.style.width = `${safeProgress}%`);
    this.loadingLabelEl && (this.loadingLabelEl.textContent = `Loading ${safeProgress}%`);
  }
  hideLoadingOverlay() {
    if (!this.loadingOverlayEl) return;
    const overlay = this.loadingOverlayEl;
    overlay.style.opacity = "0";
    setTimeout(() => {
      if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
    }, 240);
    this.loadingOverlayEl = null;
    this.loadingBarEl = null;
    this.loadingLabelEl = null;
  }

  // onAnalyticsReady() {

  //   const remoteValueKey = "levelProgression";
  //   let value = config.sdk.getAnalyticsModule().getRemoteConfig(remoteValueKey, false);
  //   // value = "true";

  //   if (value == "true") {

  //     config.levelProgressionMode = true;

  //     config.header.initLevel();
  //     config.ui.setlevelProgressionUI();
  //     config.skinPop.setBtns();
  //     config.skinPop.setUp();

  //   }

  // }

  startLoadingGameHandler() {
    this.initLoadingOverlay();
    this.updateLoadingOverlay(0);
    youtubePlayables.firstFrameReady();
    let app = new App();
    config.app = app;
    config.app.init();
    config.app.loadinProgress(this.progressLoadingHandler);

    // fin de chargement des assets
    config.app.onGameReady(this.endLoadingHandler);
    this.globalAssetsTime = new Date().getTime();
    this.notifyLoadingCompleteTime = new Date().getTime();
    this.globalTime = new Date().getTime();

    //lancement du chargement des assets
    config.app.startLoading();
  }
  endLoadingHandler() {
    this.globalAssetsTime = tools.timeToSec(new Date().getTime() - this.globalAssetsTime);
    config.sdk.getAnalyticsModule().onCustomEvent("inGame_globalAssets", this.globalAssetsTime);
    this.notifyLoadingCompleteTime = tools.timeToSec(new Date().getTime() - this.notifyLoadingCompleteTime);
    config.sdk.getAnalyticsModule().onCustomEvent("inGame_notifyLoadingComplete", this.notifyLoadingCompleteTime);
    config.app.trace("100%");
    config.app.trace("notifyLoadingComplete");
    this.updateLoadingOverlay(100);
    youtubePlayables.firstFrameReady();

    if (config.platform === 'ios') {
      this._showIOSPlayButton();
    } else {
      config.sdk.getPlatform().notifyLoadingComplete();
      this.hideLoadingOverlay();
    }
  }
  _showIOSPlayButton() {
    if (!this.loadingOverlayEl) return;
    const overlay = this.loadingOverlayEl;

    // Clear existing content and show a Play button
    overlay.innerHTML = '';
    overlay.style.background = '#0b2944';
    overlay.style.cursor = 'pointer';

    const btn = document.createElement('div');
    btn.textContent = '▶  PLAY';
    btn.style.cssText = [
      'color:#ffffff',
      'font-family:Arial,sans-serif',
      'font-size:26px',
      'font-weight:bold',
      'background:#10b7fe',
      'border-radius:50px',
      'padding:18px 60px',
      'cursor:pointer',
      'user-select:none',
      '-webkit-tap-highlight-color:transparent',
      'box-shadow:0 4px 24px rgba(0,0,0,0.4)',
      'pointer-events:none',
    ].join(';');

    let started = false;
    const onPlay = (ev) => {
      if (started) return;
      started = true;
      if (ev && ev.preventDefault) ev.preventDefault();
      if (ev && ev.stopPropagation) ev.stopPropagation();

      // Eagerly load/instantiate Howl sounds WITHIN this user gesture.
      // This ensures the AudioContext is created/unlocked on iOS so audio
      // plays without requiring a second tap.
      try { assets.loadSound(); } catch (_) {}

      // Resume context if it already exists and is suspended.
      if (Howler.ctx && (Howler.ctx.state === 'suspended' || Howler.ctx.state === 'interrupted')) {
        Howler.ctx.resume().catch(() => {});
      }
      config._audioUnlocked = true;

      // Start background music as soon as it's loaded (respect soundOn if set).
      const startMusic = () => {
        const music = config.AllHowlerAudios && config.AllHowlerAudios.MusicBackground;
        if (!music) return;
        if (config.soundOn === false) return;
        if (!music.playing()) music.play();
      };
      const music = config.AllHowlerAudios && config.AllHowlerAudios.MusicBackground;
      if (music) {
        if (music.state() === 'loaded') {
          startMusic();
        } else {
          music.once('load', startMusic);
        }
      }

      config.sdk.getPlatform().notifyLoadingComplete();
      this.hideLoadingOverlay();
    };

    // Any tap anywhere on the overlay (button or background) starts the game
    overlay.addEventListener('click', onPlay);
    overlay.addEventListener('touchend', onPlay);

    overlay.appendChild(btn);
    youtubePlayables.gameReady();
  }
  progressLoadingHandler(progress) {
    config.sdk.getPlatform().notifyLoadingProgress(progress, true);
    this.updateLoadingOverlay(progress);
  }
  _startGame() {
    this.localTime = new Date().getTime();
    localeManager.init(() => {
      assets.local = localeManager.words;
      config.app.trace("assets.local:" + assets.local);
      this.localTime = tools.timeToSec(new Date().getTime() - this.localTime);
      config.sdk.getAnalyticsModule().onCustomEvent("inGame_localisation", this.localTime);

      // after all loading and inits
      this.next();
    });
  }
  next() {
    config.app.trace("next");
    config.app.startGame(() => {
      config.app.trace("startGame");
      config.ui.featuresInit();
      config.level.initUI();
      config.touchAccess = true;
      this.loadUserSettings();
    });
  }
  async loadUserSettings() {
    this.sdkDatasTime = new Date().getTime();
    const data = await config.sdk.getStoreModule().get(["selectedSkin", "user", "coins", "bomb", "rocket", "swap", "hammer", "purchasedTheme", "haptic", "soundAccess", "noads", "level"]);
    config.staringData = data;

    /*
        data.level = {value: 100}
        data.bomb = {value: 2}
        data.rocket = {value: 2}
        data.swap = {value: 2}
        data.hammer = {value: 2}*/

    config.userDatasReady = true;
    config.purchasedTheme = data?.purchasedTheme?.value ? data.purchasedTheme.value : [config.selectedSkin];
    config.selectedSkin = data?.selectedSkin?.value || config.selectedSkin;
    if (data.user) {
      config.oldScore = data.user.score ? data.user.score : 0;
    }
    config.savedScoreAccess = true;
    if (data.coins) {
      config.oldCoins = data.coins.value ? data.coins.value : 0;
    }
    if (data.bomb) {
      config.boosterMenuBombVal = data.bomb.value != null ? data.bomb.value : -1;
    } else {
      config.boosterMenuBombVal = -1;
    }
    if (data.rocket) {
      config.boosterMenuRocketVal = data.rocket.value != null ? data.rocket.value : -1;
    } else {
      config.boosterMenuRocketVal = -1;
    }
    if (data.swap) {
      config.boosterMenuSwapVal = data.swap.value != null ? data.swap.value : -1;
    } else {
      config.boosterMenuSwapVal = -1;
    }
    if (data.hammer) {
      config.boosterMenuHammerVal = data.hammer.value != null ? data.hammer.value : -1;
    } else {
      config.boosterMenuHammerVal = -1;
    }
    config.haptic = data.haptic ? data.haptic.value : null;
    config.soundAccess = data.soundAccess ? data.soundAccess.value : true;
    if (data.noads) {
      config.noAds = data.noads.value ? true : false;
    }
    if (data.level) {
      config.playerLevel = data.level.value || config.playerLevel;
    }
    config.dataReady();
    this.getDatasCallBack();
  }
  sdkLoadedHandler() {
    this._startGame();
  }
  initFromReconnect() {
    if (config.resetProfilesDelayCall) {
      config.resetProfilesDelayCall.kill();
    }
    config.app.trace("Reconnect");
    config.header.initPlayers();
  }
  getDatasCallBack() {
    this.sdkDatasTime = tools.timeToSec(new Date().getTime() - this.sdkDatasTime);
    config.sdk.getAnalyticsModule().onCustomEvent("inGame_getSdkDatas", this.sdkDatasTime);
    config.header.initOldScore(config.oldScore);
    config.boosterMenu.bombVal = config.boosterMenuBombVal;
    config.boosterMenu.rocketVal = config.boosterMenuRocketVal;
    config.boosterMenu.swapVal = config.boosterMenuSwapVal;
    config.boosterMenu.hammerVal = config.boosterMenuHammerVal;
    config.boosterMenu.scale.set(.5);
    gsap.to(config.boosterMenu.scale, {
      delay: 1,
      duration: .5,
      x: 1,
      y: 1,
      onStart: () => {
        config.boosterMenu.visible = true;
      }
    });

    // config.parametre.init();
    // config.parametreBtn.visible = true;

    config.level.updateCoins(config.oldCoins);
    gsap.delayedCall(config.gpuTierInfo.tier > 1 ? .5 : 1, () => {
      config.noAds && config.homeMenu.removeAds();
      config.skinPop.setUp();
      config.ui.setBtns();
    });

    // chargement des profiles

    gsap.delayedCall(config.gpuTierInfo.tier > 1 ? .25 : .5, () => {
      if (config.header) config.header.initPlayers();
    });
    assets.loadSound();
    youtubePlayables.syncAudioFromYouTube();
    youtubePlayables.gameReady();
  }
}

//Launch
new Game();

// --- iOS resume-audio popup (shown when returning from background with sound ON) ---
function showIOSAudioPopup() {
  if (!config.soundOn) return;
  if (document.getElementById('ios-audio-resume')) return;
  const lang = (config.locale || (typeof navigator !== 'undefined' && navigator.language ? navigator.language.slice(0, 2) : 'en')).toLowerCase();
  const i18n = {
    en: { title: 'CLICK TO ENABLE SOUND', ok: 'OK' },
    fr: { title: 'CLIQUEZ POUR ACTIVER LE SON', ok: 'OK' },
    it: { title: "CLICCA PER ATTIVARE L'AUDIO", ok: 'OK' },
    de: { title: 'KLICKEN, UM TON ZU AKTIVIEREN', ok: 'OK' },
    es: { title: 'PULSA PARA ACTIVAR EL SONIDO', ok: 'OK' },
    pt: { title: 'CLIQUE PARA ATIVAR O SOM', ok: 'OK' }
  };
  const texts = i18n[lang] || i18n.en;

  const overlay = document.createElement('div');
  overlay.id = 'ios-audio-resume';
  overlay.style.cssText = 'position:fixed;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;background:rgba(0,0,0,0.7);z-index:99999;';

  const title = document.createElement('div');
  title.textContent = texts.title;
  title.style.cssText = 'color:#fff;font-family:Arial,sans-serif;font-size:22px;font-weight:bold;margin-bottom:20px;text-align:center;padding:0 20px;';

  const btn = document.createElement('div');
  btn.textContent = texts.ok;
  btn.style.cssText = 'color:#fff;font-family:Arial,sans-serif;font-size:20px;font-weight:bold;background:#10b7fe;border-radius:12px;padding:12px 40px;cursor:pointer;';

  const dismiss = () => {
    if (Howler.ctx && (Howler.ctx.state === 'suspended' || Howler.ctx.state === 'interrupted')) {
      Howler.ctx.resume();
    }
    if (config.soundOn && config.AllHowlerAudios?.MusicBackground) {
      config.AllHowlerAudios.MusicBackground.play();
    }
    config._audioUnlocked = true;
    if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
  };
  btn.addEventListener('click', dismiss, { once: true });
  btn.addEventListener('touchstart', dismiss, { once: true, passive: true });

  overlay.appendChild(title);
  overlay.appendChild(btn);
  document.body.appendChild(overlay);
}

// --- Page focus / audio lifecycle ---
let _pageFocusInitialized = false;
function handlePageFocus() {
  // Unlock AudioContext on every user-gesture call (needed for iOS / autoplay policy)
  if (Howler.ctx) {
    const ctxState = Howler.ctx.state;
    if (ctxState === 'suspended' || ctxState === 'interrupted') {
      Howler.ctx.resume().then(() => {
        config._audioUnlocked = true;
        if (config.soundOn && config.AllHowlerAudios?.MusicBackground && !config.AllHowlerAudios.MusicBackground.playing()) {
          config.AllHowlerAudios.MusicBackground.play();
        }
      }).catch(() => {});
    } else if (ctxState === 'running') {
      config._audioUnlocked = true;
    }
  }
  // Also try immediately (works when context is already running)
  if (config.soundOn && config.AllHowlerAudios?.MusicBackground && !config.AllHowlerAudios.MusicBackground.playing()) {
    config.AllHowlerAudios.MusicBackground.play();
  }

  if (_pageFocusInitialized) return;
  _pageFocusInitialized = true;

  const isIOS = config.platform === 'ios';

  const muteGameAudio = () => {
    config.youtubePlayables && config.youtubePlayables.pausePlaytime();
    if (config.AllHowlerAudios?.MusicBackground?.playing()) {
      config.AllHowlerAudios.MusicBackground.pause();
      config.MutedByFocus = true;
    }
  };
  const resumeGameAudio = () => {
    if (document.hidden) return;
    config.youtubePlayables && config.youtubePlayables.resumePlaytime();
    config.youtubePlayables && config.youtubePlayables.syncAudioFromYouTube();
    if (!config.soundOn) return;

    const playMusic = () => {
      if (config.AllHowlerAudios?.MusicBackground && !config.AllHowlerAudios.MusicBackground.playing()) {
        config.AllHowlerAudios.MusicBackground.play();
      }
    };

    const ctxState = Howler.ctx ? Howler.ctx.state : 'running';
    if (ctxState === 'suspended' || ctxState === 'interrupted') {
      // iOS requires a real user gesture — show a popup.
      if (isIOS) {
        showIOSAudioPopup();
        return;
      }
      // Desktop/Android: the focus event can often resume the context.
      Howler.ctx.resume().then(playMusic).catch(() => {});
    } else {
      playMusic();
    }
  };

  window.addEventListener('focus', resumeGameAudio);
  window.addEventListener('blur', muteGameAudio);
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      muteGameAudio();
      return;
    }
    resumeGameAudio();
  });
  window.addEventListener('pagehide', muteGameAudio);
  window.addEventListener('beforeunload', muteGameAudio);
  // iOS Safari fires pageshow (with persisted=true) when returning from a bfcache freeze.
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) resumeGameAudio();
  });
}

// Unlock audio on first user interaction (click or touch).
// Keep retrying until Howler.ctx exists and is unlocked (sounds may not be loaded on first tap).
function firstInteractionHandler() {
  handlePageFocus();
  if (config._audioUnlocked) {
    document.removeEventListener('click', firstInteractionHandler);
    document.removeEventListener('touchstart', firstInteractionHandler);
  }
}
document.addEventListener('click', firstInteractionHandler);
document.addEventListener('touchstart', firstInteractionHandler, { passive: true });

// --- Fullscreen ---
function GoFullScreen() {
  const isFullscreen = document.fullscreenElement || document.webkitFullscreenElement || document.msFullscreenElement;
  if (!isFullscreen) {
    const gameCanvas = document.querySelector('canvas');
    const fullscreenTarget = gameCanvas || document.documentElement || document.body;
    if (fullscreenTarget.requestFullscreen) {
      fullscreenTarget.requestFullscreen().catch(() => {});
    } else if (fullscreenTarget.webkitRequestFullscreen) {
      fullscreenTarget.webkitRequestFullscreen();
    } else if (fullscreenTarget.msRequestFullscreen) {
      fullscreenTarget.msRequestFullscreen();
    } else if (fullscreenTarget.webkitEnterFullscreen) {
      fullscreenTarget.webkitEnterFullscreen();
    }
  }
}
document.addEventListener('pointerdown', GoFullScreen, { once: false });
document.addEventListener('touchstart', GoFullScreen, { once: false, passive: true });
document.addEventListener('click', GoFullScreen, { once: false });

config.GoFullScreen = GoFullScreen;
config.handlePageFocus = handlePageFocus;
